<template>
  <footer id="footer" class="footer">
    <div class="container">
      <div class="row gy-4">
        <div class="col-lg-5 col-md-12 footer-info">
          <a href="/" class="logo d-flex align-items-center">
            <span>Golai.Еxpress</span>
          </a>
          <p>
            Дешево, Быстро, Везде! Ваши грузы, наши рекордные сроки, невероятно
            низкие цены.
          </p>
          <div class="social-links d-flex mt-4">
            <a href="https://wa.me/996700449925" class="twitter"
              ><i class="bi bi-whatsapp"></i
            ></a>
            <a href="https://t.me/golaiexpress" class="linkedin"
              ><i class="bi bi-telegram"></i
            ></a>
            <!-- <a href="#" class="facebook"><i class="bi bi-facebook"></i></a> -->
            <a href="https://www.instagram.com/golai.express" class="instagram"
              ><i class="bi bi-instagram"></i
            ></a>
          </div>
        </div>

        <div class="col-lg-2 col-6 footer-links">
          <h4>Перейти</h4>
          <ul>
            <li><a href="#">Главная</a></li>
            <li>
              <a href="#" @click.prevent="$emit('showModal')">Личный кабинет</a>
            </li>
          </ul>
        </div>

        <div
          class="col-lg-3 col-md-12 footer-contact text-center text-md-start">
          <h4>Контакты</h4>
          <a href="https://go.2gis.com/4r1dr" style="color: #fff"
            ><strong>Адрес:</strong> Ю. Абдрахманова 135, здание "Гранд" 0 этаж
            пер Советская/Токтогула
          </a>
          <a href="tel:+996700449925" style="color: #fff"
            ><strong>Тел:</strong> +996700449925
          </a>
          <p>
            <strong>График работы:</strong> Пн-Сб: 09:00-18:00 <br />
            <!-- <strong>Почта:</strong> info@example.com<br /> -->
          </p>
        </div>
        <div class="col-lg-2 col-6 footer-links">
          <a class="get_code" href="#" @click.prevent="$emit('getCode')"
            >Получить код</a
          >
        </div>
      </div>
    </div>

    <div class="container mt-4">
      <div class="copyright">
        &copy; Copyright <strong><span>Golai.express</span></strong
        >. Все права защищены.
      </div>
      <div class="credits"></div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "FooterMain",
};
</script>
<style>
.get_code {
  background: var(--color-primary);
  padding: 8px 20px;
  margin-left: 30px;
  border-radius: 4px;
  color: #fff !important;
}
.get_code:hover {
  background: #2756ff;
  color: #fff !important;
}
</style>
